<div class="py-2 px-3">
    <h1 mat-dialog-title>Unable To Activate Organization</h1>
    <div mat-dialog-content class="my-3">
        <div>Organization cannot be activated because no {{ requiredPolicyOrPackage }} are currently assigned to Organization #{{ organizationId }}.</div>
        <div class="mt-3">Please create needed {{ requiredPolicyOrPackage }} and try again.</div>
    </div>
    <div mat-dialog-actions class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="action-button" mat-dialog-close>
            Close
        </button>
    </div>
</div>